import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import mem from 'mem';
import store, { dispatch as storeDispatch } from '@store';
import { actions } from '@store/auth';
import { history } from '@history';
import { ApiService } from '@services';
import { ConstantsUtil } from '@utils';
import { Routes } from '@enums';

var AuthServiceClass = /*#__PURE__*/function () {
  function AuthServiceClass() {
    _classCallCheck(this, AuthServiceClass);

    _defineProperty(this, "memoizedRefreshAccessToken", mem(this.refreshAccessToken, {
      maxAge: 3000
    }));
  }

  _createClass(AuthServiceClass, [{
    key: "apiCurrentUser",
    value: function () {
      var _apiCurrentUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", ApiService.apiGet("/webapi/auth/me", {
                  blocked: false,
                  dontHandleError: true
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function apiCurrentUser() {
        return _apiCurrentUser.apply(this, arguments);
      }

      return apiCurrentUser;
    }()
  }, {
    key: "refreshAccessToken",
    value: function () {
      var _refreshAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var refreshToken;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                refreshToken = localStorage.getItem('refresh');

                if (!refreshToken) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", ApiService.apiGet("/Auth/refreshToken/".concat(refreshToken), {
                  blocked: false,
                  doNotRefreshIntercept: true,
                  anonymousRequest: true
                }));

              case 3:
                return _context2.abrupt("return", Promise.reject(new Error(ConstantsUtil.errors.TOKEN_MISSING)));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function refreshAccessToken() {
        return _refreshAccessToken.apply(this, arguments);
      }

      return refreshAccessToken;
    }()
  }, {
    key: "getCurrentUser",
    value: function () {
      var _getCurrentUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var dispatch;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch = storeDispatch;
                return _context3.abrupt("return", dispatch(actions.fetchUserRequest()));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getCurrentUser() {
        return _getCurrentUser.apply(this, arguments);
      }

      return getCurrentUser;
    }()
  }, {
    key: "getTokenLocalStorage",
    value: function getTokenLocalStorage() {
      return localStorage.getItem('access');
    }
  }, {
    key: "setTokenLocalStorage",
    value: function setTokenLocalStorage(accessToken, refreshToken) {
      localStorage.setItem('access', accessToken);
      localStorage.setItem('refresh', refreshToken);
    }
  }, {
    key: "removeTokenLocalStorage",
    value: function removeTokenLocalStorage() {
      localStorage.removeItem('access');
      localStorage.removeItem('refresh');
    }
  }, {
    key: "apiLogin",
    value: function () {
      var _apiLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(values) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", ApiService.apiPost('/authenticate', values, {
                  blocked: true,
                  errorRedirect: false,
                  headers: {}
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function apiLogin(_x) {
        return _apiLogin.apply(this, arguments);
      }

      return apiLogin;
    }()
  }, {
    key: "apiLogout",
    value: function apiLogout() {
      return ApiService.apiGet('/Auth/logout', {
        blocked: false
      });
    }
  }, {
    key: "isAuthenticated",
    get: function get() {
      var currentAuthState = store.getState().auth;
      return !!currentAuthState.user;
    }
  }, {
    key: "goToAuthRoute",
    value: function goToAuthRoute() {
      history.push(Routes.Error);
    }
  }, {
    key: "decodeJWTToken",
    value: function decodeJWTToken(token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    }
  }]);

  return AuthServiceClass;
}();

var AuthService = new AuthServiceClass();
export { AuthService };